import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import {
  addCorporateDirector,
  updateCorporateDirector,
  getCorporateDirector,
  deleteCorporateDirector,
  // getCorporateDocumentTypes,
  getCorporateDocument,
  deleteCorporateDocument,
  addBankAccount,
  updateBankAccount,
  getBankAccount,
  deleteBankAccount,
} from "../api/corporate-director";
import { submitCorporateDocuments } from "store/api/document";

export const addCorporateDirectorAsync = createAsyncThunk(
  "corporateDirector/addCorporateDirector",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await addCorporateDirector(payload);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const updateCorporateDirectorAsync = createAsyncThunk(
  "corporateDirector/updateCorporateDirector",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await updateCorporateDirector(payload);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getCorporateDirectorAsync = createAsyncThunk(
  "corporateDirector/getCorporateDirector",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCorporateDirector();
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const deleteCorporateDirectorAsync = createAsyncThunk(
  "corporateDirector/deleteCorporateDirector",
  async (directorId: string, { rejectWithValue }) => {
    try {
      const response = await deleteCorporateDirector(directorId);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

// export const addCorporateDocumentAsync = createAsyncThunk(
//   "corporateDirector/addCorporateDocument",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await addCorporateDocument();
//       return response?.data?.Data;
//     } catch (error) {
//       if (error instanceof AxiosError)
//         if (error?.response?.data || error?.message) {
//           return rejectWithValue(
//             error?.response?.data?.Message || error?.message
//           );
//         }
//     }
//   }
// );

// export const updateCorporateDocumentAsync = createAsyncThunk(
//   "corporateDirector/updateCorporateDocument",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await updateCorporateDocument();
//       return response?.data?.Data;
//     } catch (error) {
//       if (error instanceof AxiosError)
//         if (error?.response?.data || error?.message) {
//           return rejectWithValue(
//             error?.response?.data?.Message || error?.message
//           );
//         }
//     }
//   }
// );

// export const getCorporateDocumentTypesAsync = createAsyncThunk(
//   "corporateDirector/getCorporateDocumentTypes",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await getCorporateDocumentTypes();
//       return response?.data?.Data;
//     } catch (error) {
//       if (error instanceof AxiosError)
//         if (error?.response?.data || error?.message) {
//           return rejectWithValue(
//             error?.response?.data?.Message || error?.message
//           );
//         }
//     }
//   }
// );

export const getCorporateDocumentAsync = createAsyncThunk(
  "corporateDirector/getCorporateDocument",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await getCorporateDocument(id);
      return response?.data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const deleteCorporateDocumentAsync = createAsyncThunk(
  "corporateDirector/deleteCorporateDocument",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await deleteCorporateDocument(id);
      return response?.data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const addBankAccountAsync = createAsyncThunk(
  "BankAccount/addBankAccount",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await addBankAccount(payload);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const updateBankAccountAsync = createAsyncThunk(
  "BankAccount/updateBankAccount",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await updateBankAccount(payload);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getBankAccountAsync = createAsyncThunk(
  "BankAccount/getBankAccount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBankAccount();
      if (response?.data?.Data && response?.data?.Data?.length === 0) {
        return null;
      } else {
        return response?.data?.Data;
      }
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const deleteBankAccountAsync = createAsyncThunk(
  "BankAccount/deleteBankAccount",
  async (accountId: string, { rejectWithValue }) => {
    try {
      const response = await deleteBankAccount(accountId);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const submitCorporateDocumentsAsync = createAsyncThunk(
  "corporateDirector/submitCorporateDocuments",
  async (_, { rejectWithValue }) => {
    try {
      const response = await submitCorporateDocuments();
      return response?.data?.Data || response?.data?.Message;
    } catch (error) {
      if (error instanceof AxiosError) {
        return rejectWithValue(error?.response?.data?.Message || error?.message);
      }
    }
  }
);

interface CorporateDirectorState {
  corporateDirector: any;
  corporateDocument: any;
  // corporateDocumentTypes: any[];
  bankAccounts: any[] | null;
}

const initialState: CorporateDirectorState = {
  corporateDirector: {},
  corporateDocument: {},
  // corporateDocumentTypes: [],
  bankAccounts: [],
};

const corporateDirectorSlice = createSlice({
  name: "corporateDirector",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCorporateDirectorAsync.fulfilled, (state, action) => {
        state.corporateDirector = action.payload;
      })
      .addCase(updateCorporateDirectorAsync.fulfilled, (state, action) => {
        state.corporateDirector = action.payload;
      })
      .addCase(getCorporateDirectorAsync.fulfilled, (state, action) => {
        state.corporateDirector = action.payload;
      })
      .addCase(deleteCorporateDirectorAsync.fulfilled, (state, action) => {
        state.corporateDirector = action.payload;
      })
      // .addCase(addCorporateDocumentAsync.fulfilled, (state, action) => {
      //   state.corporateDocument = action.payload;
      // })
      // .addCase(updateCorporateDocumentAsync.fulfilled, (state, action) => {
      //   state.corporateDocument = action.payload;
      // })
      // .addCase(getCorporateDocumentTypesAsync.fulfilled, (state, action) => {
      //   state.corporateDocumentTypes = action.payload;
      // })
      .addCase(getCorporateDocumentAsync.fulfilled, (state, action) => {
        state.corporateDocument = action.payload;
      })
      .addCase(deleteCorporateDocumentAsync.fulfilled, (state, action) => {
        state.corporateDocument = action.payload;
      })
      .addCase(getBankAccountAsync.fulfilled, (state, action) => {
        state.bankAccounts = action.payload;
      });
  },
});

export default corporateDirectorSlice.reducer;
